/**
 * @generated SignedSource<<63173d616cc67fb0e64ce1922f9e0ecd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StreamRecordingDisclosureSettingsUpdateMutation$variables = {
  shouldSendRecordingDisclosureEmail: boolean;
  streamId: string;
};
export type StreamRecordingDisclosureSettingsUpdateMutation$data = {
  readonly updateStreamRecordingDisclosureSettings: {
    readonly stream: {
      readonly id: string;
      readonly recordingDisclosureSettings: {
        readonly shouldSendRecordingDisclosureEmail: boolean;
      } | null;
    };
  } | null;
};
export type StreamRecordingDisclosureSettingsUpdateMutation = {
  response: StreamRecordingDisclosureSettingsUpdateMutation$data;
  variables: StreamRecordingDisclosureSettingsUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSendRecordingDisclosureEmail"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "shouldSendRecordingDisclosureEmail",
        "variableName": "shouldSendRecordingDisclosureEmail"
      },
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      }
    ],
    "concreteType": "UpdateStreamRecordingDisclosureSettings",
    "kind": "LinkedField",
    "name": "updateStreamRecordingDisclosureSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "stream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StreamRecordingDisclosureSettings",
            "kind": "LinkedField",
            "name": "recordingDisclosureSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shouldSendRecordingDisclosureEmail",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamRecordingDisclosureSettingsUpdateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StreamRecordingDisclosureSettingsUpdateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1ee21ac16ce1a5de5bc7f9ff07c49d31",
    "id": null,
    "metadata": {},
    "name": "StreamRecordingDisclosureSettingsUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation StreamRecordingDisclosureSettingsUpdateMutation(\n  $streamId: ID!\n  $shouldSendRecordingDisclosureEmail: Boolean!\n) {\n  updateStreamRecordingDisclosureSettings(streamId: $streamId, shouldSendRecordingDisclosureEmail: $shouldSendRecordingDisclosureEmail) {\n    stream {\n      id\n      recordingDisclosureSettings {\n        shouldSendRecordingDisclosureEmail\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "222e2d93710c3984c40d9574988c85d1";

export default node;
